import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapOutputHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Output;
    }
}

//# sourceMappingURL=WrapOutputHelper.js.map
